import React from 'react';
import { TextLight } from 'components/Texts';
import { Hollow, Ghost } from 'components/Buttons';
import { colors, weight, Figure } from 'globalStyle';
import { useDispatch } from 'react-redux';
import { openPopUp } from 'store/popup';
import speaker from 'assets/persons/talking-2.svg';
import { useMediaQuery } from 'hooks';
import { DialogComponent } from '.';

export const SignUp = ({
  onClick,
  isCustomText = false,
  title,
  text,
  isOpen,

}) => {
  const dispatch = useDispatch();
  const handleClick = (type) => {
    dispatch(openPopUp({ type }));
    onClick();
  };
  const isDesktop = useMediaQuery(1023);
  if (isCustomText) {
    return (
      <DialogComponent
        isOpen={isOpen}
        handleClose={onClick}
        handleBack={onClick}
        hasContactUs={false}
        width="500px"
      >
        <Figure width="130px" height="130px" mb={20}>
          <img
            src={speaker}
            alt="hombre con un altavoz"
            style={{ width: '100%', height: '100%' }}
          />
        </Figure>
        <TextLight
          color={colors.primary}
          size={18}
          weight={weight.BOLD}
          mb={20}
        >
          {title}
        </TextLight>
        <TextLight size={15} weight={weight.MEDIUM} mb={20}>
          {text}
        </TextLight>
        <Hollow
          mb={20}
          isSubmit
          onClick={() => handleClick('register')}
          style={{ width: isDesktop ? '300px' : '100%', height: '45px', padding: '10px' }}
          onColorType="primary"
        >
          Regístrate
        </Hollow>
        <TextLight mb={10} number={4} fontStyle="italic">
          ¿Ya tienes una cuenta?
          {' '}
          <Ghost
            underline
            color={colors.GRAY_2}
            isSubmit
            size={13}
            onClick={() => handleClick('login')}
            style={{ fontStyle: 'italic' }}
          >
            Inicia Sesión
          </Ghost>
        </TextLight>
      </DialogComponent>
    );
  }
  return (
    <DialogComponent
      isOpen={isOpen}
      handleClose={onClick}
      handleBack={onClick}
      hasContactUs={false}
      width="500px"
    >
      <Figure width="130px" height="130px" mb={20}>
        <img
          src={speaker}
          alt="hombre con un altavoz"
          style={{ width: '100%', height: '100%' }}
        />
      </Figure>
      <TextLight color={colors.primary} size={isDesktop ? 18 : 16} weight={weight.BOLD} mb={20}>
        Únete y comienza a invertir en nuestros proyectos
      </TextLight>
      <TextLight size={isDesktop ? 15 : 13} weight={weight.MEDIUM} mb={20} lineHeight="18px">
        Crea tu cuenta ahora y comienza a invertir en proyectos emocionantes. Tu
        próxima ganancia está a solo unos clics de distancia.
      </TextLight>
      <Hollow
        mb={20}
        isSubmit
        size={!isDesktop && 14}
        onClick={() => handleClick('register')}
        style={{ width: isDesktop ? '300px' : '100%', height: '45px', padding: '10px' }}
        onColorType="primary"
      >
        Regístrate
      </Hollow>
      <TextLight mb={10} size={13} fontStyle="italic">
        ¿Ya tienes una cuenta?
        {' '}
        <Ghost
          underline
          color={colors.GRAY_2}
          isSubmit
          size={13}
          onClick={() => handleClick('login')}
          style={{ fontStyle: 'italic' }}
        >
          Inicia Sesión
        </Ghost>
      </TextLight>
    </DialogComponent>
  );
};
